/**
 * Color utility functions
 */

/**
 * Returns 'white' or 'black' for maximum contrast against the given hex color.
 * Uses WCAG relative luminance formula with a threshold of 0.179.
 */
export function getContrastColor(hex: string): 'white' | 'black' {
  if (!hex || typeof hex !== 'string') return 'black';

  // Strip leading #
  const cleaned = hex.replace(/^#/, '');
  if (cleaned.length !== 6 && cleaned.length !== 3) return 'black';

  // Expand shorthand (e.g. "FFF" -> "FFFFFF")
  const full =
    cleaned.length === 3
      ? cleaned
          .split('')
          .map((c) => c + c)
          .join('')
      : cleaned;

  const r = parseInt(full.substring(0, 2), 16) / 255;
  const g = parseInt(full.substring(2, 4), 16) / 255;
  const b = parseInt(full.substring(4, 6), 16) / 255;

  if (isNaN(r) || isNaN(g) || isNaN(b)) return 'black';

  // sRGB to linear
  const toLinear = (c: number) => (c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4));

  const luminance = 0.2126 * toLinear(r) + 0.7152 * toLinear(g) + 0.0722 * toLinear(b);

  return luminance > 0.179 ? 'black' : 'white';
}
